import CapturePage from '../../components/CapturePage';
import LayoutScreen from '../../components/layout';
import imgBanner from '../../assets/image/banner-1.png';
import imgBannerMobile from '../../assets/image/banner.png';
import imgProduk1 from '../../assets/image/img-produk-1.png';
import iconScan from '../../assets/icon/icon_scan.svg';
import iconArrowRight from '../../assets/icon/icon_arrow_right.svg';
import Button from '../../components/button';
import ButtonLarge from '../../components/buttonLarge';
import { useNavigate } from 'react-router-dom';
import { clearBiodata } from '../../utils/helper';
import axios from 'axios';
import CONFIG from '../../config/apiConfig';
import { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import FormLogin from '../../components/formLogin';
import FormLoginFull from '../../components/formLoginFull';
import Footer from '../../components/footer';
import Cookies from 'js-cookie';

const PageLogin = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (Cookies.get('auth_token')) {
      navigate('/profile');
    }
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-lightCream to-cream">
      <div
        className={`flex flex-col flex-grow w-full h-full justify-center items-center md:max-w-screen-2xl mx-auto px-4 py-4 md:px-20`}>
        <section
          className={`relative flex flex-col w-full h-full rounded-xl md:rounded-3xl`}>
          <FormLoginFull onClose={() => {}} />
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default PageLogin;
